import React from 'react';

import { WorkspaceLayout } from '../../../shared/components/Layout';
import { Tabs } from '../../../shared/components/Tabs';
import ReviewRequestDialog from './components/ReviewRequestDialog';
import { TABS_CONFIG } from './constants';
import { ReviewRequestDialogProvider, ReviewRequestProvider } from './context';

const Lists = () => (
  <WorkspaceLayout>
    <ReviewRequestProvider>
      <ReviewRequestDialogProvider>
        <Tabs config={TABS_CONFIG} />
        <ReviewRequestDialog />
      </ReviewRequestDialogProvider>
    </ReviewRequestProvider>
  </WorkspaceLayout>
);

export default Lists;
